import moment from 'moment';
import fields from '../Field.constants';

const dates = [fields.ContractEndDate, fields.ContractReleaseDate, fields.E_MarkingStartDate, fields.E_MarkingEndDate];

const formatDate = value => moment(value).format('ddd Do MMMM YYYY');

const formatter = (field, value) => dates.includes(field) ? formatDate(value) : value;

export default formatter;